const channelName = 'auth-channel';
let broadcastChannel: BroadcastChannel | null = null;

export const getBroadcastChannel = () => {
  if (!broadcastChannel) {
    broadcastChannel = new BroadcastChannel(channelName);
  }
  return broadcastChannel;
};

export const closeBroadcastChannel = () => {
  if (broadcastChannel) {
    broadcastChannel.close();
    broadcastChannel = null;
  }
};
